<template>
  <BAutocomplete
    ref="autocomplete"
    v-bind="$attrs"
    label="Оценочная процедура"
    no-data-text="Процедура не найдена"
    :request="request"
    item-value="id"
    item-text="name"
    v-on="$listeners"
  />
</template>

<script>
import { openApiMixin } from './mixins'

import { Adapter } from '@/store/createCrudModule'

import BAutocomplete from '../BAutocomplete.vue'
import { ProceduresApi } from '@/api/resources/ProceduresApi'


export default {
  name: 'BAutocompleteProcedure',
  components: {
    BAutocomplete,
  },
  mixins: [
    openApiMixin,
  ],
  created() {
    const api = new ProceduresApi()
    this.adapter = new Adapter(api)
  },
  methods: {
    request(params, ...args) {
      const { model } = this
      return this.adapter.api.getMarks({ ...params, model }, ...args)
    },
  },
}
</script>
